module.exports = __webpack_public_path__ + "img/Icon_Networking.6d6c22d.svg";